export const DEFAULT_ORG = 'LCS'

export const getOrgOptions = (t: (key: string) => string) => [
  { id: 'org-lcs', value: DEFAULT_ORG, label: t('org-lcs-label') },
  { id: 'org-gcs', value: 'GCS', label: t('org-gcs-label') },
];

// Generic Yes/No options generator
const getYesNoOptions = (
  fieldPrefix: string,
  yesValue: string,
  noValue: string,
  t: (key: string) => string
) => [
  { id: `${fieldPrefix}-yes`, value: yesValue, label: t('yes-label') },
  { id: `${fieldPrefix}-no`, value: noValue, label: t('no-label') },
];

export enum RO_IN_VALUE {
  YES = 'ro-in-1',
  NO = 'ro-in-2'
}

export const getRoOptions = (t: (key: string) => string) =>
  getYesNoOptions('ro', RO_IN_VALUE.YES, RO_IN_VALUE.NO, t);

export enum BRAND_CONFIRMATION_VALUE {
  YES = 'brand-confirmation-1',
  NO = 'brand-confirmation-2'
}

export const getBrandConfirmationOptions = (t: (key: string) => string) =>
  getYesNoOptions('brand-confirmation', BRAND_CONFIRMATION_VALUE.YES, BRAND_CONFIRMATION_VALUE.NO, t);

enum CREATIVES_OPTIONS {
  closed = 'CLOSED',
  firstCutReceived = 'FIRST_CUT_RECEIVED',
  notReceived = 'NOT_RECEIVED',
}

export const CREATIVES_API_TO_FORM_MAPPING: Record<string, string> = {
  CLOSED: 'creatives-1',
  FIRST_CUT_RECEIVED: 'creatives-2',
  NOT_RECEIVED: 'creatives-3',
};

export const getCreativesOptions = (t: (key: string) => string) => [
  {
    id: 'creatives-closed',
    value: CREATIVES_API_TO_FORM_MAPPING[CREATIVES_OPTIONS.closed],
    label: t('creatives-closed-label'),
    enum: CREATIVES_OPTIONS.closed,
  },
  {
    id: 'creatives-first-cut',
    value: CREATIVES_API_TO_FORM_MAPPING[CREATIVES_OPTIONS.firstCutReceived],
    label: t('creatives-first-cut-received-label'),
    enum: CREATIVES_OPTIONS.firstCutReceived,
  },
  {
    id: 'creatives-received',
    value: CREATIVES_API_TO_FORM_MAPPING[CREATIVES_OPTIONS.notReceived],
    label: t('creatives-not-received-label'),
    enum: CREATIVES_OPTIONS.notReceived,
  },
];

export const getApiValue = (
  formValue: string
): string | undefined => {
  const entry = Object.entries(CREATIVES_API_TO_FORM_MAPPING).find(
    ([_, mappedFormValue]) => mappedFormValue === formValue
  );
  return entry ? entry[0] : undefined;
};
